import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Authentication layout components
import CustomBasicLayout from "layouts/auth/components/CustomBasicLayout";

function ActivationMessage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Set a timeout to automatically redirect to login after 10 seconds
    const timer = setTimeout(() => {
      navigate("/login");
    }, 10000);

    // Clean up the timer if the component unmounts
    return () => clearTimeout(timer);
  }, [navigate]);

  const handleRedirect = () => {
    navigate("/login");
  };

  return (
    <CustomBasicLayout>
      <Card sx={{ maxWidth: 420, width: "100%", p: 4, borderRadius: 3 }}>
        {/* Logo/Icon */}
        <MDBox display="flex" flexDirection="column" alignItems="center" mb={3}>
          <MDBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            width={80}
            height={80}
            borderRadius="50%"
            sx={{
              background: "linear-gradient(135deg, #5a6a94 0%, #465475 100%)",
              boxShadow: "0 4px 20px rgba(70, 84, 117, 0.3)",
              mb: 2,
            }}
          >
            <Icon sx={{ fontSize: 36, color: "white" }}>email</Icon>
          </MDBox>
          <MDTypography variant="h4" fontWeight="bold" color="dark">
            Check Your Email
          </MDTypography>
        </MDBox>

        {/* Message Content */}
        <MDBox textAlign="center" mb={3}>
          <MDTypography variant="body1" color="text" sx={{ mb: 2 }}>
            We've sent an activation email to your inbox.
          </MDTypography>
          <MDTypography variant="body1" color="text" sx={{ mb: 2 }}>
            Please check your email (and spam folder) to activate your account.
          </MDTypography>
          <MDTypography variant="body2" color="text" sx={{ fontStyle: "italic" }}>
            You will be automatically redirected to the login page in 10 seconds.
          </MDTypography>
        </MDBox>

        {/* Continue Button */}
        <MDButton
          variant="gradient"
          color="info"
          fullWidth
          size="large"
          onClick={handleRedirect}
          sx={{
            borderRadius: 3,
            py: 1.5,
            textTransform: "none",
            fontSize: "1rem",
          }}
        >
          Continue to Login
        </MDButton>
      </Card>
    </CustomBasicLayout>
  );
}

export default ActivationMessage;